import React from "react";

const BreadcrumbSolution = () => {
  return (
    <section
      className="slider__area pt-120"
      style={{ overflow: "hidden", borderRadius: 12, marginBottom: 0 }}
    >
      <div className="slider__active swiper-container">
        <div
          className="slider__item p-relative"
          style={{
            position: "relative",
            minHeight: "clamp(360px, 45vw, 560px)",
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          {/* Video element */}
          <video
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            autoPlay
            loop
            muted
          >
            <source
              src="/assets/img/products/FA/1_Eagle_Vizion_FA.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          {/* Gradient overlay for readability */}
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.45) 100%)",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default BreadcrumbSolution;
